import {FilterType} from '../../interfaces/reducers/homeState';

export const staticDrugsFilters: FilterType[] = [
  {
    items: [
      {id: 95, value: 'A'},
      {id: 96, value: 'B'},
      {id: 97, value: 'C'},
      {id: 98, value: 'D'},
      {id: 99, value: 'E'},
      {id: 100, value: 'F'},
      {id: 101, value: 'G'},
      {id: 102, value: 'H'},
      {id: 103, value: 'I'},
      {id: 104, value: 'J'},
      {id: 105, value: 'K'},
      {id: 106, value: 'L'},
      {id: 107, value: 'M'},
      {id: 108, value: 'N'},
      {id: 109, value: 'O'},
      {id: 110, value: 'P'},
      {id: 111, value: 'Q'},
      {id: 112, value: 'R'},
      {id: 113, value: 'S'},
      {id: 114, value: 'T'},
      {id: 115, value: 'U'},
      {id: 116, value: 'V'},
      {id: 117, value: 'W'},
      {id: 118, value: 'X'},
      {id: 119, value: 'Y'},
      {id: 120, value: 'Z'},
    ],
    key: 'letter_id',
    label: 'Letter',
    static: true,
  },
];
